var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newsEcharts"},[_c('div',{ref:"lineChartPatent",staticClass:"lineChart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }